import { render } from "./phone_icon.vue?vue&type=template&id=0b8fa894&scoped=true"
import script from "./phone_icon.vue?vue&type=script&lang=js"
export * from "./phone_icon.vue?vue&type=script&lang=js"

import "./phone_icon.vue?vue&type=style&index=0&id=0b8fa894&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8fa894"]])

export default __exports__